import { createClient } from "@supabase/supabase-js"
import { authStorage } from "./authStorage"

// The project address and the public (publishable / anon) key now come from the environment, so the same code serves
// every environment: the local .env points at TEST, the Vercel settings point at production.
// There is deliberately NO fallback value: if a variable is missing, the app must fail loudly instead of silently
// talking to the wrong database.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. Check your .env file (local) or the Vercel environment variables (production)."
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, { auth: { storage: authStorage } })
